
<template>
    <div>
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 10%;">
                </vs-th>
                <vs-th style="width: 35%;">
                    Clave
                </vs-th>
                <vs-th style="width: 35%;">
                    Documento
                </vs-th>
                <vs-th style="width: 20%;">
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in documentos"
                :data="tr"
                style="border-bottom: 1px solid #CACFD2"
                v-if="tr.path == null || tr.path == ''"
            >
                <vs-td>
                    <p><strong>{{ tr.id }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><small>CLAVE</small></p>
                    <p><strong>{{ tr.clave }}</strong></p>
                    <p class="mb-0"><small>NOMBRE</small></p>
                    <p><strong>{{ tr.nombre }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><small><strong>DISEÑO PERSONALIZADO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="getColorMetodo(tr.con_formato)">
                        <strong>
                            <span class="text-uppercase">{{ tr.con_formato }}</span>
                        </strong>
                    </md-chip>
                    <p class="mb-0"><small><strong>ENTREGA POR ALUMNO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="getColorMetodo(tr.requiere_respuesta)">
                        <strong>
                            <span class="text-uppercase">{{ tr.requiere_respuesta }}</span>
                        </strong>
                    </md-chip>
                    <!-- <p class="mb-0"><small><strong>ARCHIVO EXTERNO</strong></small></p>
                    <md-chip class="mb-3 fontMedium mini-chip" :class="tr.path == null || tr.path == '' ? getColorMetodo('no') : getColorMetodo('si')">
                        <strong>
                            <span class="text-uppercase">{{ tr.path == null || tr.path == '' ? 'No' : 'Si' }}</span>
                        </strong>
                    </md-chip> -->
                </vs-td>
                <vs-td>
                    <vs-button
                        flat
                        @click="activeEditar =! activeEditar, selectedRow = tr"
                    >
                        <i class="fas fa-edit mr-2"></i> Editar
                    </vs-button>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

        </vs-table>
        <editar v-model="activeEditar" :instituciones="instituciones" :row="selectedRow" @refreshTable="getRefresh" :tipoModal="tipoModal"></editar>
    </div>
</template>
<script>
import editar from './modales/editar.vue'
    export default {
        props: [
            'documentos',
            'instituciones',
        ],
        data:() => ({
            users: [
            {
                "id": 1,
                "name": "Leanne Graham",
                "username": "Bret",
                "email": "Sincere@april.biz",
                "website": "hildegard.org",
            },
            {
                "id": 2,
                "name": "Ervin Howell",
                "username": "Antonette",
                "email": "Shanna@melissa.tv",
                "website": "anastasia.net",
            },
            {
                "id": 3,
                "name": "Clementine Bauch",
                "username": "Samantha",
                "email": "Nathan@yesenia.net",
                "website": "ramiro.info",
            },
            {
                "id": 4,
                "name": "Patricia Lebsack",
                "username": "Karianne",
                "email": "Julianne.OConner@kory.org",
                "website": "kale.biz",
            },
            {
                "id": 5,
                "name": "Chelsey Dietrich",
                "username": "Kamren",
                "email": "Lucio_Hettinger@annie.ca",
                "website": "demarco.info",
            },
            {
                "id": 6,
                "name": "Mrs. Dennis Schulist",
                "username": "Leopoldo_Corkery",
                "email": "Karley_Dach@jasper.info",
                "website": "ola.org",
            },
            {
                "id": 7,
                "name": "Kurtis Weissnat",
                "username": "Elwyn.Skiles",
                "email": "Telly.Hoeger@billy.biz",
                "website": "elvis.io",
            },
            {
                "id": 8,
                "name": "Nicholas Runolfsdottir V",
                "username": "Maxime_Nienow",
                "email": "Sherwood@rosamond.me",
                "website": "jacynthe.com",
            },
            {
                "id": 9,
                "name": "Glenna Reichert",
                "username": "Delphine",
                "email": "Chaim_McDermott@dana.io",
                "website": "conrad.com",
            },
            {
                "id": 10,
                "name": "Clementina DuBuque",
                "username": "Moriah.Stanton",
                "email": "Rey.Padberg@karina.biz",
                "website": "ambrose.net",
            }
            ],
            activeEditar: false,
            selectedRow: [],
            tipoModal: 'crear'
        }),
        components: {
            editar
        },
        methods:{
            getColorMetodo(diseno){
                if (diseno === 'no'){
                    return 'col-red'
                }
                if (diseno === 'si'){
                    return 'col-green'
                }
            },
            getRefresh(){
                this.$emit('refreshTable')
            }
        }
    }
</script>

<style scoped>
    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>

        